<template>
  <div
    id="app"
    class="bb-page-container"
  >
    <transition name="fade" appear>
      <loader-fly v-if="loaderRun"></loader-fly>
    </transition>
    <template v-if="$route.name !== 'SingIn'">
      <NotificationsBar/>
      <Sidebar :loaderRun.sync="loaderRun"/>
      <VuePerfectScrollbar
        class="bb-right-panel"
        :class="{
          'bb-right-panel_qualification' : isQualificationRout,
        }"
        ref="rightPanel"
        @ps-scroll-y="scrollEventY"
      >
        <template v-if="!isQualificationRout">
          <transition  name="routing-fade" v-on:scrolltop="scrollTop" appear>
            <router-view/>
          </transition>
        </template>
        <template v-else>
          <router-view/>
        </template>
      </VuePerfectScrollbar>
    </template>
    <template v-else>
      <router-view/>
    </template>
    <transition name="bounce">
      <NotificationsWindow/>
    </transition>
    <transition name="bounce">
      <TimerControl v-if="isShowTimerPanel"/>
    </transition>
    <transition name="bounce">
      <BBTimerModal
        v-if="isShowTimerModalFinance"
        :style="positionPopup"
        :isShowModal.sync="isShowTimerModalFinance"
      />
    </transition>
  </div>
</template>

<script>
import Sidebar from './components/Main/Sidebar'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import CompaniesApi from './api/Companies/api'
import userApi from './api/User/api'
import LoaderFly from './components/Main/Loaders/LoaderFly'
import {FOUNDER, CEO, ACCOUNTANT} from '@/constants/roles'
import { SIDE_HOURLY } from '@/constants/projectTypes'
import { IN_PROGRESS_PROJECT } from '@/constants/projectStatuses'
import { DOMAINS } from '@/constants/domainListPlatform'
import _, {get} from 'lodash'
import ProjectListApi from '@/api/ProjectsList/api'
import NotificationsBar from '@/components/Notifications/NotificationsBar/NotificationsBar'
import isSignedIn from '@/mixin/checkSignInGmail'
import setWatchGoogle from '@/mixin/setWatchGoogle'
import NotificationsWindow from '@/components/Notifications/NotificationsWindow/NotificationsWindow'
import TimerControl from '@/components/Main/TimerControl/TimerControl'
import TimerApi from '@/api/Timer/api'
import BBTimerModal from '@/components/Main/TimerControl/BBTimerModal/BBTimerModal'

export default {
  name: 'App',
  components: {
    BBTimerModal,
    TimerControl,
    NotificationsWindow,
    NotificationsBar,
    Sidebar,
    VuePerfectScrollbar,
    LoaderFly
  },
  comments: {
    Sidebar
  },
  mixins: [isSignedIn, setWatchGoogle],
  data: function () {
    return {
      loaderRun: false,
      scrollTopPosition: 0,
      positionPopup: {
        position: 'fixed',
        bottom: '95px',
        right: '40px'
      }
    }
  },
  computed: {
    isQualificationRout () {
      return this.$route.path.includes('wiki') || this.$route.path.includes('academy')
    },
    currentDomain: {
      get: function () {
        return this.$store.getters.currentDomain
      },
      set: function (data) {
        this.$store.dispatch('setCurrentDomain', data)
      }
    },
    mainScroll: {
      get: function () {
        return this.$store.getters.mainScroll
      },
      set: function (data) {
        this.$store.dispatch('setMainScroll', data)
      }
    },
    companiesList: {
      get: function () {
        return this.$store.getters.companiesList
      },
      set: function (data) {
        this.$store.dispatch('setCompaniesList', data)
      }
    },
    activeCompany: {
      get: function () {
        return this.$store.getters.activeCompany
      },
      set: function (data) {
        this.$store.dispatch('setActiveCompany', data)
      }
    },
    userInfo: {
      get: function () {
        return this.$store.getters.userInfo
      },
      set: function (data) {
        this.$store.dispatch('setUserInfo', data)
      }
    },
    gapi: {
      get: function () {
        return this.$store.getters.gapi
      },
      set: function (data) {
        this.$store.dispatch('setGapi', data)
      }
    },
    notificationsList () {
      return this.$store.getters.notificationsList
    },
    isShowTimerPanel: {
      get () {
        return this.$store.getters.isShowTimerPanel
      },
      set (data) {
        this.$store.dispatch('setShowTimer', data)
      }
    },
    time: {
      get () {
        return this.$store.getters.time
      },
      set (data) {
        this.$store.dispatch('setTimer', data)
      }
    },
    activeTimer: {
      get () {
        return this.$store.getters.activeTimer
      },
      set (data) {
        this.$store.dispatch('setActiveTimer', data)
      }
    },
    isShowTimerModalFinance: {
      get () {
        return this.$store.getters.isShowTimerModalFinance
      },
      set (data) {
        this.$store.dispatch('setShowTimerModalFinance', data)
      }
    }
  },
  methods: {
    scrollEventY (e) {
      this.mainScroll = e
    },
    getCompanyById () {
      CompaniesApi.getCompaniesById(this.activeCompany)
        .then(({data}) => {
          this.$store.dispatch('setCurrentCompany', data)
        })
        .catch((err) => {
          console.error(err)
        })
    },
    getCompany: function () {
      this.loaderRun = true
      CompaniesApi.getCompanies()
        .then(({data}) => {
          const {companies} = data
          this.companiesList = companies
          const activeCompany = companies.find(({id}) => id === this.activeCompany)
          if (activeCompany) {
            this.$store.dispatch('setCurrentCompany', activeCompany)
          } else if (this.companiesList.length > 0) {
            const [activeCompany] = this.companiesList
            const {id} = activeCompany
            this.activeCompany = id
            this.$store.dispatch('setCurrentCompany', activeCompany)
            this.$cookie.set('company', id)
          }
          this.loaderRun = false
        })
        .catch((err) => {
          this.loaderRun = false
          console.error(err)
        })
    },
    getUser: function () {
      this.loaderRun = true
      userApi.getUser()
        .then((resp) => {
          this.loaderRun = false
          this.userInfo = resp.data
          this.checkedAccess()
          if (!this.$cookie.get('company')) {
            this.activeCompany = resp.data.company
            this.$cookie.set('company', this.userInfo.company)
          } else {
            this.activeCompany = this.$cookie.get('company')
          }
          if (resp.data.role === FOUNDER.id) {
            this.getCompany()
          } else {
            this.getCompanyById()
          }
          if (this.$route.name === 'SingIn') {
            this.$router.push({name: 'Dashboard'})
          }
          this.getActiveTimer()
        })
        .catch((err) => {
          this.loaderRun = false
          console.error(err)
          this.$router.push({name: 'SingIn'})
        })
    },
    scrollTop () {
      if (this.$refs.rightPanel) {
        this.$refs.rightPanel.$el.scrollTop = 0
        this.$refs.rightPanel.$el.scrollLeft = 0
      }
    },
    checkedAccess () {
      const role = _.get(this.userInfo, 'role', '')

      const isFounder = role === FOUNDER.id
      const isAccountant = role === ACCOUNTANT.id
      const isCeo = role === CEO.id

      if (isFounder || isCeo) return

      const routeAccess = _.get(this.$route, 'meta.access')
      const routeRolesAccess = _.get(this.$route, 'meta.accessRoles')
      const department = _.get(this.$route, 'meta.department')
      const userAccess = _.get(this.userInfo, `access.${routeAccess}`, '')
      const isRoleAllowed = routeRolesAccess && routeRolesAccess.some(({id}) => id === role)

      if ((isAccountant && routeAccess && routeAccess.includes('dissemination')) || isRoleAllowed) return

      if (department) {
        const departmentUser = get(this.userInfo, 'position.department', false)
        const isDepartmentUser = department ? department === departmentUser : true
        if (isDepartmentUser) {
          this.$router.push({name: 'MainPageCommercialOffers'})
        }
      }

      if (!userAccess && this.$route.name !== 'MainPage') {
        this.$router.push({name: 'MainPage'})
      }
    },
    async getActiveTimer () {
      const { id } = this.userInfo
      try {
        const { data } = await TimerApi.getActiveTimer(id)
        this.isShowTimerPanel = !!data.length
        if (!data.length) return
        const [ item = {} ] = data
        const { subTimers = {} } = item
        const { companies = [{}], project = [], request = [], instanceStatus } = subTimers
        const [ parentProject = {}, subProject = {} ] = project
        const [ requestProject = {} ] = request
        const { _id, client } = parentProject

        this.activeTimer = {
          ...item,
          project: _id,
          requestProject: requestProject._id,
          subprojectId: subProject._id,
          instanceStatus,
          client,
          subTimers: {
            ...subTimers,
            companies: companies.length ? companies : [{}]
          }
        }
        this.time.isFirst = true
        this.getSubProjects()
      } catch (err) {
        console.error(err)
      }
    },
    async getSubProjects () {
      const { project, subprojectId } = this.activeTimer
      if (!subprojectId) return
      try {
        const { data } = await ProjectListApi.getProjects({
          parentProjectId: project,
          projectType: SIDE_HOURLY.id,
          status: IN_PROGRESS_PROJECT.id
        })
        const { projects = [] } = data
        projects.forEach((el) => {
          el.id = el._id
        })
        this.activeTimer.subProjectsList = projects
      } catch (err) {
        console.error(err)
      }
    },
    checkDomainPlatform () {
      const { location = {} } = window
      const { href } = location
      const currentItem = DOMAINS.find((el) => {
        const { name } = el
        return href.includes(name)
      })
      this.currentDomain = currentItem
    }
  },
  updated () {
    this.scrollTop()
  },
  beforeMount () {
    if (!this.$cookie.get('googleToken') || !this.$cookie.get('token')) {
      if (this.$route.name === 'SingIn') return
      this.$router.push({name: 'SingIn'})
    } else {
      this.checkDomainPlatform()
      this.getUser()
    }
  }
}
</script>

<style lang="scss">
@import "sass/style";

.bb-right-panel {
  padding: 40px 50px;
  flex-grow: 1;
  height: 100%;
  max-height: 100%;
  overflow: hidden;

  @media (max-width: 1440px) {
    padding: 40px 30px;
  }

  &_qualification {
    padding: 0;

    @media (max-width: 1440px) {
      padding: 0;
    }
  }

}
</style>



// WEBPACK FOOTER //
// src/App.vue